import { render } from "./AffectedLists.vue?vue&type=template&id=04931b70&scoped=true"
import script from "./AffectedLists.vue?vue&type=script&lang=js"
export * from "./AffectedLists.vue?vue&type=script&lang=js"

import "./AffectedLists.vue?vue&type=style&index=0&id=04931b70&scoped=true&lang=scss"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04931b70"]])

export default __exports__